import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateSLAStatusRequestDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type Params = {
  code: string;
  onSuccess?: () => void;
  onError?: (error: ExtendedAxiosError) => void;
};

export function useUpdateSLAStatus({ code, onSuccess, onError }: Params) {
  const api = useApi();

  const queryClient = useQueryClient();

  return useMutation<void, ExtendedAxiosError, UpdateSLAStatusRequestDto>({
    mutationKey: ['issues', code, 'update-sla-status'],
    mutationFn: (r) =>
      api.issuesApi.updateSLAStatus(code, r).then((r) => r.data),
    onSuccess: async () => {
      onSuccess?.();
      // TODO: instead of invalidating, return the updated issue data
      await queryClient.invalidateQueries({ queryKey: ['issues', code] });
    },
    onError: (err) => {
      onError?.(err);
    },
  });
}
